"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classnames = _interopRequireDefault(require("classnames"));

var _zod = require("zod");

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _LazyImage = _interopRequireDefault(require("@insided/shared/uikit/LazyImage"));

var _ChevronRight = _interopRequireDefault(require("@insided/shared/icons/ChevronRight"));

var _trackingLink = _interopRequireDefault(require("../link/tracking-link"));

var _widgetContainer = _interopRequireWildcard(require("@insided/deprecated-preact-components/widget-container"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var widgetName = 'badges';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-badges';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  title: _zod.z.string(),
  amount: _zod.z.number().default(5)
}).merge(_widgetContainer.widgetContainerConfig);

exports.config = config;

var BadgesEarned = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(BadgesEarned, _Component);

  var _super = _createSuper(BadgesEarned);

  function BadgesEarned() {
    (0, _classCallCheck2.default)(this, BadgesEarned);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(BadgesEarned, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          badges = _this$props.badges,
          config = _this$props.config;
      var classNames = 'box widget widget--badges qa-widget-badges';
      if (!badges.length) return null;
      return (0, _preact.h)(_widgetContainer.default, {
        widgetName: widgetName,
        config: config,
        className: classNames
      }, (0, _preact.h)("div", null, (0, _preact.h)(_trackingLink.default, {
        tag: "ul",
        track: {
          type: 'Sidebar Widget Clicked',
          widget: 'badges'
        },
        gaEvents: {
          eventCategory: 'Homepage',
          eventAction: 'Widget Clicked',
          eventLabel: {
            Type: 'Badges'
          }
        },
        className: (0, _classnames.default)('list list--badges unpad--sidebar qa-badges-earned-list')
      }, badges.map(function (badge, index) {
        return (0, _preact.h)("li", {
          key: index
        }, (0, _preact.h)("div", {
          className: (0, _classnames.default)('user', 'flag', 'flag--top')
        }, (0, _preact.h)("div", {
          className: "flag__image"
        }, (0, _preact.h)(_LazyImage.default, {
          type: "img",
          src: (0, _absoluteUrlRuntime.resolveUrl)(badge.image),
          title: badge.title,
          alt: badge.title
        })), (0, _preact.h)("div", {
          className: "user_data flag__body"
        }, (0, _preact.h)("a", {
          className: "link username",
          href: (0, _absoluteUrlRuntime.resolveUrl)(badge.userUrl)
        }, badge.username), (0, _preact.h)("span", {
          className: "text--meta"
        }, (0, _preact.h)(_phrase.default, {
          p: "has earned the badge {badgetitle}",
          count: {
            badgetitle: badge.title
          }
        })))));
      })), (0, _preact.h)("a", {
        className: (0, _classnames.default)('btn--cta', 'btn--show-more', 'link', 'link--underline', 'widget--badges__btn-more'),
        href: (0, _absoluteUrlRuntime.resolveUrl)("/badges")
      }, (0, _preact.h)(_phrase.default, {
        p: "Show all badges"
      }), (0, _preact.h)(_ChevronRight.default, {
        className: "badges-link-text-icon",
        height: 20,
        width: 20
      }))));
    }
  }]);
  return BadgesEarned;
}(_preact.Component);

exports.default = BadgesEarned;